import { MobileOnlyContainer } from './MobileOnlyContainer';

const name = 'MobileOnlyContainer';

export { MobileOnlyContainer, name };
